"use strict";

var match = require('./match');

function notMatch() {
  return !match.apply(void 0, arguments);
}

module.exports = notMatch;